module.exports = __webpack_public_path__ + "img/product1.cb40a9c3.png";